module.exports = __webpack_public_path__ + "img/checkboxEle.7c7d7415.svg";